import type { ChangeEvent } from 'react'

import { Input } from '@/components'
import { FilterInputWrapper } from './FilterInputWrapper'
import type { AmountInputProps } from './types'

export function AmountInput({
  label = 'Amount',
  value,
  onChange,
  onKeyDown,
  placeholder = '0.00',
}: AmountInputProps) {
  return (
    <FilterInputWrapper label={label}>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
          $
        </span>
        <Input
          type="number"
          step="0.01"
          placeholder={placeholder}
          value={value}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
          onKeyDown={onKeyDown}
          className="pl-7"
        />
      </div>
    </FilterInputWrapper>
  )
}
